import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import toolsD59410 from './tools'
/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::index
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:40
* @route '/app/agents/{agent}/mcp'
*/
export const index = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/agents/{agent}/mcp',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::index
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:40
* @route '/app/agents/{agent}/mcp'
*/
index.url = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { agent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { agent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            agent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
    }

    return index.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::index
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:40
* @route '/app/agents/{agent}/mcp'
*/
index.get = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::index
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:40
* @route '/app/agents/{agent}/mcp'
*/
index.head = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::index
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:40
* @route '/app/agents/{agent}/mcp'
*/
const indexForm = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::index
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:40
* @route '/app/agents/{agent}/mcp'
*/
indexForm.get = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::index
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:40
* @route '/app/agents/{agent}/mcp'
*/
indexForm.head = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::store
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:78
* @route '/app/agents/{agent}/mcp'
*/
export const store = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/agents/{agent}/mcp',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::store
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:78
* @route '/app/agents/{agent}/mcp'
*/
store.url = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { agent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { agent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            agent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
    }

    return store.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::store
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:78
* @route '/app/agents/{agent}/mcp'
*/
store.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::store
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:78
* @route '/app/agents/{agent}/mcp'
*/
const storeForm = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::store
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:78
* @route '/app/agents/{agent}/mcp'
*/
storeForm.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::destroy
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:122
* @route '/app/agents/{agent}/mcp/{mcpServer}'
*/
export const destroy = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/agents/{agent}/mcp/{mcpServer}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::destroy
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:122
* @route '/app/agents/{agent}/mcp/{mcpServer}'
*/
destroy.url = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            agent: args[0],
            mcpServer: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
        mcpServer: typeof args.mcpServer === 'object'
        ? args.mcpServer.id
        : args.mcpServer,
    }

    return destroy.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace('{mcpServer}', parsedArgs.mcpServer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::destroy
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:122
* @route '/app/agents/{agent}/mcp/{mcpServer}'
*/
destroy.delete = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::destroy
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:122
* @route '/app/agents/{agent}/mcp/{mcpServer}'
*/
const destroyForm = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::destroy
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:122
* @route '/app/agents/{agent}/mcp/{mcpServer}'
*/
destroyForm.delete = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::test
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:133
* @route '/app/agents/{agent}/mcp/{mcpServer}/test'
*/
export const test = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: test.url(args, options),
    method: 'post',
})

test.definition = {
    methods: ["post"],
    url: '/app/agents/{agent}/mcp/{mcpServer}/test',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::test
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:133
* @route '/app/agents/{agent}/mcp/{mcpServer}/test'
*/
test.url = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            agent: args[0],
            mcpServer: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
        mcpServer: typeof args.mcpServer === 'object'
        ? args.mcpServer.id
        : args.mcpServer,
    }

    return test.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace('{mcpServer}', parsedArgs.mcpServer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::test
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:133
* @route '/app/agents/{agent}/mcp/{mcpServer}/test'
*/
test.post = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: test.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::test
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:133
* @route '/app/agents/{agent}/mcp/{mcpServer}/test'
*/
const testForm = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: test.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::test
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:133
* @route '/app/agents/{agent}/mcp/{mcpServer}/test'
*/
testForm.post = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: test.url(args, options),
    method: 'post',
})

test.form = testForm

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::refresh
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:162
* @route '/app/agents/{agent}/mcp/{mcpServer}/refresh'
*/
export const refresh = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refresh.url(args, options),
    method: 'post',
})

refresh.definition = {
    methods: ["post"],
    url: '/app/agents/{agent}/mcp/{mcpServer}/refresh',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::refresh
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:162
* @route '/app/agents/{agent}/mcp/{mcpServer}/refresh'
*/
refresh.url = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            agent: args[0],
            mcpServer: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
        mcpServer: typeof args.mcpServer === 'object'
        ? args.mcpServer.id
        : args.mcpServer,
    }

    return refresh.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace('{mcpServer}', parsedArgs.mcpServer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::refresh
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:162
* @route '/app/agents/{agent}/mcp/{mcpServer}/refresh'
*/
refresh.post = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refresh.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::refresh
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:162
* @route '/app/agents/{agent}/mcp/{mcpServer}/refresh'
*/
const refreshForm = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refresh.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::refresh
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:162
* @route '/app/agents/{agent}/mcp/{mcpServer}/refresh'
*/
refreshForm.post = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refresh.url(args, options),
    method: 'post',
})

refresh.form = refreshForm

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::tools
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:173
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
export const tools = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tools.url(args, options),
    method: 'get',
})

tools.definition = {
    methods: ["get","head"],
    url: '/app/agents/{agent}/mcp/{mcpServer}/tools',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::tools
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:173
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
tools.url = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            agent: args[0],
            mcpServer: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
        mcpServer: typeof args.mcpServer === 'object'
        ? args.mcpServer.id
        : args.mcpServer,
    }

    return tools.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace('{mcpServer}', parsedArgs.mcpServer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::tools
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:173
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
tools.get = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tools.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::tools
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:173
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
tools.head = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: tools.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::tools
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:173
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
const toolsForm = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: tools.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::tools
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:173
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
toolsForm.get = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: tools.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::tools
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:173
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
toolsForm.head = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: tools.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

tools.form = toolsForm

/**
* @see \App\Http\Controllers\Admin\Mcp\McpActivityController::activity
* @see app/Http/Controllers/Admin/Mcp/McpActivityController.php:21
* @route '/app/agents/{agent}/mcp/{mcpServer}/activity'
*/
export const activity = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activity.url(args, options),
    method: 'get',
})

activity.definition = {
    methods: ["get","head"],
    url: '/app/agents/{agent}/mcp/{mcpServer}/activity',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpActivityController::activity
* @see app/Http/Controllers/Admin/Mcp/McpActivityController.php:21
* @route '/app/agents/{agent}/mcp/{mcpServer}/activity'
*/
activity.url = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            agent: args[0],
            mcpServer: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
        mcpServer: typeof args.mcpServer === 'object'
        ? args.mcpServer.id
        : args.mcpServer,
    }

    return activity.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace('{mcpServer}', parsedArgs.mcpServer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpActivityController::activity
* @see app/Http/Controllers/Admin/Mcp/McpActivityController.php:21
* @route '/app/agents/{agent}/mcp/{mcpServer}/activity'
*/
activity.get = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activity.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpActivityController::activity
* @see app/Http/Controllers/Admin/Mcp/McpActivityController.php:21
* @route '/app/agents/{agent}/mcp/{mcpServer}/activity'
*/
activity.head = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: activity.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpActivityController::activity
* @see app/Http/Controllers/Admin/Mcp/McpActivityController.php:21
* @route '/app/agents/{agent}/mcp/{mcpServer}/activity'
*/
const activityForm = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpActivityController::activity
* @see app/Http/Controllers/Admin/Mcp/McpActivityController.php:21
* @route '/app/agents/{agent}/mcp/{mcpServer}/activity'
*/
activityForm.get = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpActivityController::activity
* @see app/Http/Controllers/Admin/Mcp/McpActivityController.php:21
* @route '/app/agents/{agent}/mcp/{mcpServer}/activity'
*/
activityForm.head = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

activity.form = activityForm

const mcp = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
    test: Object.assign(test, test),
    refresh: Object.assign(refresh, refresh),
    tools: Object.assign(tools, toolsD59410),
    activity: Object.assign(activity, activity),
}

export default mcp